import React from 'react';
import { NotFoundView } from '@shared/ui/seo/seo';
import { usePageDocumentTitle } from '../hooks/useDocumentTitle';
import { MainLayout } from '../layouts';

/** An address that isn't a page: the shared view in this app's frame. Marked noindex, so search engines drop it. */
const NotFoundPage: React.FC = () => {
  usePageDocumentTitle('Page not found');
  return (
    <MainLayout>
      <NotFoundView />
    </MainLayout>
  );
};

export default NotFoundPage;
